(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-raw-gallery]').forEach((gallery) => {
      if (gallery.dataset.initialized) return;
      const slides = Array.from(gallery.querySelectorAll('[data-raw-media]'));
      if (!slides.length) return;
      const thumbnails = Array.from(gallery.querySelectorAll('[data-raw-thumbnail]'));
      const stage = gallery.querySelector('.raw-gallery__stage');
      const status = gallery.querySelector('[data-raw-status]');
      const controls = gallery.querySelector('.raw-gallery__controls');
      const previous = gallery.querySelector('[data-raw-previous]');
      const next = gallery.querySelector('[data-raw-next]');
      const hint = gallery.querySelector('[data-raw-hint]');
      let activeIndex = 0;

      const show = (index, focusThumbnail = false) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          if (!active && !slide.hidden) {
            slide.querySelectorAll('video').forEach((video) => video.pause());
            slide.querySelectorAll('iframe').forEach((frame) => {
              const source = frame.getAttribute('src');
              if (source) frame.setAttribute('src', source);
            });
            slide.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
          }
          slide.hidden = !active;
        });
        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const active = thumbnailIndex === activeIndex;
          thumbnail.tabIndex = active ? 0 : -1;
          if (active) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
        status.textContent = slides[activeIndex].dataset.mediaStatus;
        if (focusThumbnail) thumbnails[activeIndex]?.focus({ preventScroll: true });
        const thumbnail = thumbnails[activeIndex];
        if (thumbnail) {
          const rail = thumbnail.closest('.raw-gallery__thumbnails');
          const left = thumbnail.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
          if (left < rail.scrollLeft) rail.scrollLeft = left;
          else if (left + thumbnail.offsetWidth > rail.scrollLeft + rail.clientWidth) {
            rail.scrollLeft = left + thumbnail.offsetWidth - rail.clientWidth;
          }
        }
      };

      const showMedia = (mediaId) => {
        let target = String(mediaId || '');
        if (target === gallery.dataset.duplicateMedia) target = gallery.dataset.fallbackMedia;
        const index = slides.findIndex((slide) => slide.dataset.rawMedia === target);
        if (index !== -1) show(index);
      };

      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', (event) => {
          event.preventDefault();
          show(index);
        });
        thumbnail.addEventListener('keydown', (event) => {
          let target;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = activeIndex + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = activeIndex - 1;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = slides.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          show(target, true);
        });
      });
      previous.addEventListener('click', () => show(activeIndex - 1));
      next.addEventListener('click', () => show(activeIndex + 1));
      stage.addEventListener('keydown', (event) => {
        if (event.target.closest('video, iframe, model-viewer, button, input, select, textarea')) return;
        let target;
        if (event.key === 'ArrowRight') target = activeIndex + 1;
        if (event.key === 'ArrowLeft') target = activeIndex - 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = slides.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        show(target);
        stage.focus({ preventScroll: true });
      });

      const productSection = gallery.closest('[data-raw-product]');
      const variantSelect = productSection?.querySelector('[data-variant-select]');
      const syncVariant = () => {
        const option = variantSelect?.selectedOptions[0];
        if (option?.dataset.mediaId) showMedia(option.dataset.mediaId);
      };
      variantSelect?.addEventListener('change', syncVariant);
      gallery.classList.add('is-enhanced');
      gallery.dataset.initialized = 'true';
      controls.hidden = false;
      previous.hidden = slides.length < 2;
      next.hidden = slides.length < 2;
      hint.hidden = slides.length < 2;
      show(0);
      showMedia(gallery.dataset.initialMedia);
      syncVariant();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
